module.exports = __webpack_public_path__ + "img/NA.a58013a8.png";